'use client'

import {
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronsLeftIcon,
  ChevronsRightIcon,
} from 'lucide-react'
import { useTranslations } from 'next-intl'

import { Button, IconButton } from '../../ui/button'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../ui/select'

interface IClientPaginationProps {
  pageIndex: number
  pageCount: number
  pageSize: number
  pageSizeOptions: number[]
  setPageIndex: (pageIndex: number) => void
  setPageSize: (pageSize: number) => void
}
export default function ClientPagination({
  pageIndex,
  pageCount,
  pageSize,
  pageSizeOptions,
  setPageIndex,
  setPageSize,
}: IClientPaginationProps) {
  const t = useTranslations('client-pagination')
  const onPageSizeChange = (value: string) => {
    setPageSize(Number(value))
  }
  return (
    <div className="flex flex-wrap items-center gap-0 sm:gap-4 lg:gap-6 text-xs sm:text-sm">
      <div className="flex items-center gap-2">
        <p className="font-medium">{t('items-per-page')}</p>
        <Select value={String(pageSize)} onValueChange={onPageSizeChange}>
          <SelectTrigger className="h-8 w-[70px]">
            <SelectValue placeholder={pageSize} />
          </SelectTrigger>
          <SelectContent side="top">
            {pageSizeOptions.map((pageSize) => (
              <SelectItem key={pageSize} value={`${pageSize}`}>
                {pageSize}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="flex min-w-[100px] items-center justify-center font-medium">
        {t('page-index', {
          pageIndex: pageIndex + 1,
          pageCount: Math.max(pageCount, 1),
        })}
      </div>
      <div className="flex items-center gap-2">
        <IconButton
          onClick={() => setPageIndex(0)}
          disabled={pageIndex === 0 || pageCount === 0}
        >
          <span className="sr-only">Go to first page</span>
          <ChevronsLeftIcon className="size-4" />
        </IconButton>
        <IconButton
          onClick={() => setPageIndex(pageIndex - 1)}
          disabled={pageIndex === 0 || pageCount === 0}
        >
          <span className="sr-only">Go to previous page</span>
          <ChevronLeftIcon className="size-4" />
        </IconButton>
        <IconButton
          onClick={() => setPageIndex(pageIndex + 1)}
          disabled={pageIndex === pageCount - 1 || pageCount === 0}
        >
          <span className="sr-only">Go to next page</span>
          <ChevronRightIcon className="size-4" />
        </IconButton>
        <IconButton
          onClick={() => setPageIndex(pageCount - 1)}
          disabled={pageIndex === pageCount - 1 || pageCount === 0}
        >
          <span className="sr-only">Go to last page</span>
          <ChevronsRightIcon className="size-4" />
        </IconButton>
      </div>
    </div>
  )
}
